import React from "react";
import styled, { space, SpaceProps } from "../../../../../styles";

export const StyledGroup = styled(({ mb, mt, ...rest }) => (
  <div {...rest} />
))<SpaceProps>`
  ${space}
`;
